import { ApiProperty } from '@nestjs/swagger';
import { IsNotEmpty, IsOptional, IsString, MaxLength } from 'class-validator';

export class CreateMarcaDto {
  @ApiProperty({ example: 'SAMSUNG', description: 'Código de la marca' })
  @IsOptional()
  @IsString()
  @MaxLength(20)
  codigo?: string;

  @ApiProperty({ example: 'Samsung Electronics', description: 'Descripción de la marca' })
  @IsNotEmpty()
  @IsString()
  @MaxLength(100)
  descripcion: string;
}
